import { render, staticRenderFns } from "./Customers.create.vue?vue&type=template&id=6c3538d3&"
import script from "./Customers.create.vue?vue&type=script&lang=js&"
export * from "./Customers.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports